import { Component } from '@angular/core';

@Component({
  selector: 'app-opin-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss'],
  standalone: false
})
export class OpinDividerComponent {}
